/**
 * Dependencies
 */
import React from 'react';
import TagManager from 'react-gtm-module';

/**
* Enviroremnts
*/
import commonUtil from '../../utils/commonUtil';
import serverClientUtil from '../../utils/serverClientUtil';

/**
 * @object_tagManagerArgs Se crea un objecto por enviroment apuntado a los keys de GTM
 */
const tagManagerArgs = {};
let isInitTgm = false;

class Tagging extends React.Component {

  componentDidMount() {
    if (!isInitTgm) {
      if (typeof window !== 'undefined' && window) {
        TagManager.initialize(tagManagerArgs);
        isInitTgm = true;
      }
    }
  }

  applyGTM(pageName, extraData) {  
    if (typeof window !== 'undefined' && window) {
      const _tagManagerArgs = {};
      _tagManagerArgs.dataLayerName = 'dataLayer';
      _tagManagerArgs.dataLayer = extraData;

      TagManager.dataLayer(_tagManagerArgs);
    }
  }

  render() {
    const GTMKeys = serverClientUtil.getGTMKey(commonUtil.getBrand());
    tagManagerArgs.gtmId = GTMKeys.GTMID;
    tagManagerArgs.auth = GTMKeys.Auth;
    tagManagerArgs.preview = GTMKeys.previewID;
    return null;
  }
}

export default Tagging;
